import { GraphErrors } from './errors';
type ContentErrorType =
  | 'DEFAULT'
  | 'MISSING_CONTENT'
  | 'CHARACTER_COUNT_EXCEEDS_500'
  | 'ONLY_SPACE_CHARACTERS'
  | 'BLACKLISTED_WORDS'
  | 'RATE_LIMIT_EXCEEDED'
  | 'INVALID_TITLE_LENGTH'
  | 'UNAUTHORIZED_REPLY'
  | 'NO_TOPIC_SELECTION';

export class ContentValidationError extends GraphErrors {
  constructor(public readonly key: ContentErrorType = 'DEFAULT') {
    super(key);
    this.name = 'ContentValidationError';
  }
}

export const validateContent = (content: string): void => {
  if (!content) throw new ContentValidationError('MISSING_CONTENT');
  if (content.length > 500)
    throw new ContentValidationError('CHARACTER_COUNT_EXCEEDS_500');
  if (!content.trim())
    throw new ContentValidationError('ONLY_SPACE_CHARACTERS');
};

export const validateThread = (content: string, categoryId: string): void => {
  validateContent(content);
  if (!categoryId) throw new ContentValidationError('NO_TOPIC_SELECTION');
};
